/**
 * Angular Material Theme Configuration
 * This file sets up the Material Design theme that can be customized per portal
 */

/**
 * Convert HSL to RGB for Material Design palettes
 * HSL format: "211 55% 25%" -> RGB
 */
function hslToRgb(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l - c / 2;
  let r = 0, g = 0, b = 0;

  if (0 <= h && h < 60) {
    r = c; g = x; b = 0;
  } else if (60 <= h && h < 120) {
    r = x; g = c; b = 0;
  } else if (120 <= h && h < 180) {
    r = 0; g = c; b = x;
  } else if (180 <= h && h < 240) {
    r = 0; g = x; b = c;
  } else if (240 <= h && h < 300) {
    r = x; g = 0; b = c;
  } else if (300 <= h && h < 360) {
    r = c; g = 0; b = x;
  }
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return `rgb(${r}, ${g}, ${b})`;
}

/**
 * Generate Material palette from HSL base color
 */
function generatePalette(h: number, s: number, baseL: number) {
  return {
    50: hslToRgb(h, s, baseL + 40),
    100: hslToRgb(h, s, baseL + 30),
    200: hslToRgb(h, s, baseL + 20),
    300: hslToRgb(h, s, baseL + 10),
    400: hslToRgb(h, s, baseL + 5),
    500: hslToRgb(h, s, baseL),
    600: hslToRgb(h, s, baseL - 5),
    700: hslToRgb(h, s, baseL - 10),
    800: hslToRgb(h, s, baseL - 15),
    900: hslToRgb(h, s, baseL - 20),
  };
}

export const materialThemeConfig = {
  // Legal Resources Brand Colors - Primary: Dark Navy (211 55% 25%)
  primaryPalette: generatePalette(211, 55, 25),
  
  // Accent: Red (359 73% 49%)
  accentPalette: generatePalette(359, 73, 49),
  
  // Warn: Destructive Red (359 73% 49%)
  warnPalette: generatePalette(359, 73, 49),
};

/**
 * Typography configuration
 */
export const typographyConfig = {
  fontFamily: '"Roboto", "Helvetica Neue", sans-serif',
  fontSize: {
    h1: '2.5rem',
    h2: '2rem',
    h3: '1.75rem',
    h4: '1.5rem',
    h5: '1.25rem',
    h6: '1rem',
    body1: '1rem',
    body2: '0.875rem',
    button: '0.875rem',
    caption: '0.75rem',
  }
};


